import { useContext } from 'react';

import {
  PaymentGatewayActionContext,
  PaymentGatewayValueContext,
} from './context';

const usePaymentGatewayValue = () => {
  const context = useContext(PaymentGatewayValueContext);
  if (!context) {
    throw new Error(
      'usePaymentGatewayValue must be used within a <PaymentGatewayFormContext />',
    );
  }
  return context;
};

const usePaymentGatewayAction = () => {
  const context = useContext(PaymentGatewayActionContext);
  if (!context) {
    throw new Error(
      'usePaymentGatewayAction must be used within a <PaymentGatewayFormContext />',
    );
  }
  return context;
};

export { usePaymentGatewayAction, usePaymentGatewayValue };
